<template>
  <div class="tab-pane fade  active show" id="scenic-manage" role="tabpanel" aria-labelledby="scenic-manage-tab">
    <div class="container-fluid">
      <div>
        <!--景區設定-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="col-md-3 d-flex align-items-end">
              <div class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="addScenicArea">
                <i class="fas fa-plus"></i> 新增
              </div>
            </div>

            <div class="row">
              <div class="col-12  table-responsive">
                <table :class="tableStyle">
                  <thead class="table-dark text-center">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="20%">風景區</th>
                      <th scope="col" width="35%">位置</th>
                      <th scope="col" width="35%">設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in scenicAreaList" :key="key">
                      <td :class="tableCenterStyle">{{ key + 1 }}</td>
                      <td :class="tableCenterStyle">{{ item.name }}</td>
                      <td :class="tableCenterStyle">{{ item.areasSort }}</td>
                      <td :class="tableCenterStyle">
                        <button class="btn btn-primary bg-indigo mb-1  mx-1" @click="editScenicArea(item)">
                          編輯
                        </button>
                        <button class="btn btn-danger mb-1  mx-1" @click="(e) => deleteScenicArea(item, e)">
                          刪除
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <dialog-modal ref="ScenicAreaEditor" :showUpdateButton="true" :customUpdateButton="selectScenicArea? '修改':'新增'"
      :modalSize="''" :isImage="false" :isMarginAuto="false" @update-button-click="implement">
      <div class="pb-1">
        <div class="form-group h6">
          <label for="exampleInputEmail1">名稱</label>
          <input type="text" class="form-control" min="0" v-model.number="selectScenicAreaName" />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">順序</label>
          <input type="number" class="form-control" min="1" step="1" v-model.number="selectScenicAreaSort" />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">緯度</label>
          <input type="number" class="form-control" min="1" step="1" v-model.number="selectLatitude" />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">經度</label>
          <input type="number" class="form-control" min="1" step="1" v-model.number="selectLongitude" />
        </div>
        <div class="form-group h6">
          <label for="exampleInputEmail1">景區功能</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="CAR_FLOW" v-model="isCarFlowCheck">
            <label class="form-check-label" for="CAR_FLOW">
              車輛辨識
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="PEOPLE_ANALYZE" v-model="isPeopleAnalyzeCheck">
            <label class="form-check-label" for="PEOPLE_ANALYZE">
              遊客屬性分析
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="WEATHER_INFO" v-model="isWetherInfoCheck">
            <label class="form-check-label" for="WEATHER_INFO">
              天氣資訊
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="CLOSE_IN_ADVANCE"
              v-model="isCloseInAdvanceCheck">
            <label class="form-check-label" for="CLOSE_IN_ADVANCE">
              管制設定
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="TOILET_PEOPLE_FLOW"
              v-model="isToiletPeopleFlowCheck">
            <label class="form-check-label" for="TOILET_PEOPLE_FLOW">
              廁所人流
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="TOILET_DEVICE" v-model="isToiletDevice">
            <label class="form-check-label" for="TOILET_DEVICE">
              公廁維運
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="VIOLATION" v-model="isViolation">
            <label class="form-check-label" for="VIOLATION">
              違規闖入
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="SOS" v-model="isSOS">
            <label class="form-check-label" for="SOS">
              緊急求救
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="EINK" v-model="isEink">
            <label class="form-check-label" for="EINK">
              電子紙
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="HUMAN_SENSOR" v-model="isHumanSensor">
            <label class="form-check-label" for="HUMAN_SENSOR">
              人體偵測
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="WATER_METER" v-model="isSmartWater">
            <label class="form-check-label" for="WATER_METER">
              智慧水表
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="ELECTRIC_METER" v-model="isSmartElectric">
            <label class="form-check-label" for="ELECTRIC_METER">
              智慧電表
            </label>
          </div>

        </div>  
      </div>
    </dialog-modal>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from 'vuex'
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import { getCountPerHour } from '../../api/elasticSearch/vehicleplateApi'
import exportCSV from '../../utils/exportCSV'
import DialogModal from '../../components/DialogModal.vue'


export default {
  data() {
    return {
      CONST: CONST,
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center ",
      tableCenterStyle: "text-center align-middle",
      selectScenicArea: null,
      selectScenicAreaName: '',
      selectScenicAreaSort: 0,
      selectLatitude: 0,
      selectLongitude: 0,
      isCarFlowCheck: false,
      isPeopleAnalyzeCheck: false,
      isWetherInfoCheck: false,
      isCloseInAdvanceCheck: false,
      isToiletPeopleFlowCheck: false,
      isToiletDevice: false,
      isViolation: false,
      isSOS: false,
      isEink: false,
      isHumanSensor: false,
      isSmartWater: false,
      isSmartElectric: false,
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
  },
  watch: {
    selectScenicArea() {

    }
  },
  methods: {
    addScenicArea() {
      this.selectScenicArea = null
      this.selectScenicAreaName = ""
      this.selectScenicAreaSort = 0
      this.selectLatitude = 0
      this.selectLongitude = 0
      this.isCarFlowCheck = false
      this.isPeopleAnalyzeCheck = false
      this.isWetherInfoCheck = false
      this.isCloseInAdvanceCheck = false
      this.isToiletPeopleFlowCheck = false
      this.isToiletDevice = false
      this.isViolation = false
      this.isSOS = false
      this.isEink = false
      this.isHumanSensor = false
      this.isSmartElectric = false

      this.$refs.ScenicAreaEditor.openModal()
    },

    editScenicArea(item) {
      this.$refs.ScenicAreaEditor.openModal()
      this.selectScenicArea = item
      this.selectScenicAreaName = item.name
      this.selectScenicAreaSort = item.areasSort
      this.selectLatitude = item.latitude
      this.selectLongitude = item.longitude
      this.isCarFlowCheck = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW
      this.isPeopleAnalyzeCheck = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE
      this.isWetherInfoCheck = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO
      this.isCloseInAdvanceCheck = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CLOSE_IN_ADVANCE
      this.isToiletPeopleFlowCheck = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.TOILET_PEOPLE_FLOW
      this.isToiletDevice = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PROVIDER_TOILET_DEVICE
      this.isViolation = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.VIOLATION
      this.isSOS = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SOS
      this.isEink = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.EINK_DISPLAY
      this.isHumanSensor = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.HUMAN_SENSOR
      this.isSmartWater = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SMART_WATER_METER
      this.isSmartElectric = this.selectScenicArea.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SMART_ELECRTIC_METER
    },

    async deleteScenicArea(item, e) {
      e.preventDefault(); //防止confirm後 scroll to top 
      const isCheck = confirm('確認刪除此景區 ?')
      if(!isCheck) {
        return 
      }
      const result =await this.$store.dispatch("scenicArea/deleteScenicArea",item);
      if (result.success) {
        return

      } else if(result.status === 409){
        alert("此景區下尚有地點，無法刪除");
      }
      else {
        alert("刪除失敗");
      }
    },

    implement() {
      if(this.selectScenicArea) {
        this.updateScenicArea()
      } else {
        this.createScenicArea()
      }
    },

    async createScenicArea() {
      let scenicArea = {
        name: this.selectScenicAreaName,
        areasSort: this.selectScenicAreaSort,
        latitude: this.selectLatitude,
        longitude: this.selectLongitude,
        additionInfo : this.computeAdditionInfo()
      }
      const result = await this.$store.dispatch('scenicArea/postScenicArea', scenicArea)

      if (result.success) {
        this.$refs.ScenicAreaEditor.closeModal();
      } else {
        alert('新增失敗')
      }
    },

    async updateScenicArea() {
      if(this.selectScenicAreaSort < 0) {
        alert("順序不可以為負數")
        return
      }

      let addtionInfo = this.computeAdditionInfo()

      this.selectScenicArea.additionInfo = addtionInfo
      this.selectScenicArea.name = this.selectScenicAreaName
      this.selectScenicArea.areasSort = this.selectScenicAreaSort
      this.selectScenicArea.latitude = this.selectLatitude
      this.selectScenicArea.longitude = this.selectLongitude
      const result = await this.$store.dispatch('scenicArea/putScenicArea', this.selectScenicArea)

      if (result.success) {
        this.$refs.ScenicAreaEditor.closeModal();
      } else {
        alert('修改失敗')
      }

    },

    computeAdditionInfo() {
      let addtionInfo = 0
      if (this.isCarFlowCheck) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW
      }

      if (this.isPeopleAnalyzeCheck) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE
      }

      if (this.isWetherInfoCheck) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO
      }

      if (this.isCloseInAdvanceCheck) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CLOSE_IN_ADVANCE
      }

      if (this.isToiletPeopleFlowCheck) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.TOILET_PEOPLE_FLOW
      }

      if (this.isToiletDevice) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PROVIDER_TOILET_DEVICE
      }

      if (this.isViolation) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.VIOLATION
      }

      if (this.isSOS) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SOS
      }

      if (this.isEink) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.EINK_DISPLAY
      }

      if (this.isHumanSensor) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.HUMAN_SENSOR
      }

      if (this.isSmartWater) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SMART_WATER_METER
      }

      if (this.isSmartElectric) {
        addtionInfo = addtionInfo + CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SMART_ELECRTIC_METER
      }

      return addtionInfo
    }
  },
  mounted() {
  },
  components: { DialogModal },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
</style>
